import {
    SET_SCREAMS, LOADING_DATA, LIKE_SCREAM,
    UNLIKE_SCREAM, DELETE_SCREAM, LOADING_UI,
    SET_ERRORS, CLEAR_ERRORS, POST_SCREAM,
    SET_SCREAM, STOP_LOADING_UI, SUBMIT_COMMENT
} from '../types';
import axios from 'axios';
import { getUserData as getAuthenticatedUserData } from './userActions';

const normalizeScreamPayload = (data, screamId) => ({
    ...data,
    screamId: data?.screamId || data?.id || screamId
});

const getCurrentScream = (state, screamId) => {
    if (state.data.scream.screamId === screamId) return state.data.scream;
    return state.data.screams.find(scream => scream.screamId === screamId);
};

const shouldRefreshScreamPayload = (state, screamId, payload, likeDelta) => {
    const currentScream = getCurrentScream(state, screamId);
    if (!currentScream || typeof currentScream.likeCount !== 'number') return !payload.screamId;

    return payload.likeCount !== currentScream.likeCount + likeDelta;
};

const fetchUpdatedScream = (dispatch, screamId, type) => {
    return axios.get(`/scream/${screamId}`)
        .then(res => {
            dispatch({
                type,
                payload: normalizeScreamPayload(res.data, screamId)
            });
        });
};

// Get All screams
export const getScreams = _ => dispatch => {
    dispatch({ type: LOADING_DATA });
    return axios.get('/screams')
        .then(res => {
            dispatch({
                type: SET_SCREAMS,
                payload: res.data
            });
        })
        .catch(err => {
            console.log('getScreams axios => ', { err });
            dispatch({
                type: SET_SCREAMS,
                payload: []
            });
        });
};

// Get one scream
export const getScream = screamId => dispatch => {
    dispatch({ type: LOADING_UI });
    axios.get(`/scream/${screamId}`)
        .then(res => {
            dispatch({
                type: SET_SCREAM,
                payload: res.data
            });
            dispatch({ type: STOP_LOADING_UI });
        })
        .catch(err => console.log({ err }));
};

// Like a scream
export const likeScream = screamId => (dispatch, getState) => {
    return axios.post(`/scream/${screamId}/like`)
        .then(res => {
            const payload = normalizeScreamPayload(res.data, screamId);

            if (shouldRefreshScreamPayload(getState(), screamId, payload, 1)) {
                return Promise.all([
                    fetchUpdatedScream(dispatch, screamId, LIKE_SCREAM),
                    dispatch(getAuthenticatedUserData(true))
                ]);
            }

            dispatch({
                type: LIKE_SCREAM,
                payload
            });

            return dispatch(getAuthenticatedUserData(true));
        })
        .catch(err => {
            if (err.response && err.response.status === 304) {
                return Promise.all([
                    fetchUpdatedScream(dispatch, screamId, LIKE_SCREAM),
                    dispatch(getAuthenticatedUserData(true))
                ]);
            }

            console.log(err);
            throw err;
        });
};

// Unlike a scream
export const unlikeScream = screamId => (dispatch, getState) => {
    return axios.post(`/scream/${screamId}/unlike`)
        .then(res => {
            const payload = normalizeScreamPayload(res.data, screamId);

            if (shouldRefreshScreamPayload(getState(), screamId, payload, -1)) {
                return Promise.all([
                    fetchUpdatedScream(dispatch, screamId, UNLIKE_SCREAM),
                    dispatch(getAuthenticatedUserData(true))
                ]);
            }

            dispatch({
                type: UNLIKE_SCREAM,
                payload
            });

            return dispatch(getAuthenticatedUserData(true));
        })
        .catch(err => {
            if (err.response && err.response.status === 304) {
                return Promise.all([
                    fetchUpdatedScream(dispatch, screamId, UNLIKE_SCREAM),
                    dispatch(getAuthenticatedUserData(true))
                ]);
            }

            console.log(err);
            throw err;
        });
};

// Sunmit a comment
export const submitComment = (screamId, commentData) => dispatch => {
    axios.post(`/scream/${screamId}/comment`, commentData)
        .then(res => {
            dispatch({
                type: SUBMIT_COMMENT,
                payload: res.data
            });
            dispatch(clearErrors());
        })
        .catch(err => {
            console.log('submitComment action ', { err });
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        });
};

// Delete a scream
export const deleteScream = screamId => dispatch => {
    axios.delete(`/scream/${screamId}`)
        .then(_ => {
            dispatch({
                type: DELETE_SCREAM,
                payload: screamId
            });
        })
        .catch(err => console.log(err));
};

// Post a scream
export const postScream = newScream => dispatch => {
    dispatch({ type: LOADING_UI });
    axios.post('/scream', newScream)
        .then(res => {
            dispatch({
                type: POST_SCREAM,
                payload: res.data
            });
            dispatch(clearErrors());
        })
        .catch(err => {
            console.log('postScream action ', { err });
            dispatch({
                type: SET_ERRORS,
                payload: err.response.data
            })
        });
};

export const getUserData = userHandle => dispatch => {
    dispatch({ type: LOADING_DATA });
    axios.get(`user/${userHandle}`)
        .then(res => {
            dispatch({
                type: SET_SCREAMS,
                payload: res.data.screams
            });
        })
        .catch(err => {
            console.log('getUserData() ', { err });
            dispatch({
                type: SET_SCREAMS,
                payload: null
            });
        });
};

export const clearErrors = _ => dispatch => dispatch({ type: CLEAR_ERRORS });
